import type { AppointmentStatus } from '../appointments/appointments.enum'

export class ScheduleSlot {
    start: Date
    end: Date
    status: ScheduleSlotStatus
    scheduleId: string
}

export enum ScheduleSlotStatus {
    agendamento_desativado = 'agendamento_desativado',
    agendamento_criado = 'agendamento_criado',
    agendamento_confirmado = 'agendamento_confirmado',
    agendamento_cancelado_usuario = 'agendamento_cancelado_usuario',
    agendamento_cancelado_empresa = 'agendamento_cancelado_empresa',
    agendamento_faltou = 'agendamento_faltou',
    agendamento_compareceu = 'agendamento_compareceu',
    agendamento_remarcado = 'agendamento_remarcado',
    agendamento_remarcado_descontar = 'agendamento_remarcado_descontar',
    agendamento_excluido = 'agendamento_excluido',
    agendamento_bloqueado = 'agendamento_bloqueado',
    agendamento_disponivel = 'agendamento_disponivel',
}
